module.exports = __webpack_public_path__ + "img/forecast_ratios.c91c1f81.png";